import { useI18n } from 'vue-i18n'

export default function table_list() {
  const { t } = useI18n()
  /**
   * 表格属性说明
   * label:表头标题,这里记录的是i18n属性值
   * prop:对应列内容的字段名
   * align:列的对齐方式
   * disabled:列是否允许禁用显隐功能
   * show:列是否展现
   * minWidth:列最小宽度
   */
  return [
    {
      label: t('recharge_list.table.created_at'),
      prop: 'created_at',
      align: 'center',
      disabled: false,
      show: true,
      minWidth: '160',
    },
    {
      label: t('recharge_list.table.recharge_amount_usd'),
      prop: 'money',
      align: 'center',
      disabled: false,
      show: true,
      minWidth: '100',
    },
    {
      label: t('recharge_list.table.payment_amount_cny'),
      prop: 'money_cny',
      align: 'center',
      disabled: false,
      show: true,
      minWidth: '160',
    },
    // {
    //   label: t('recharge_list.table.exchange_rate'),
    //   prop: 'exchange_rate',
    //   align: 'center',
    //   disabled: false,
    //   show: true,
    //   minWidth: '80',
    // },
    {
      label: t('recharge_list.table.payment_method'),
      prop: 'pay_type',
      align: 'center',
      disabled: false,
      show: true,
      minWidth: '80',
    },
    // {
    //   label: t('recharge_list.table.payment_voucher'),
    //   prop: 'voucher',
    //   align: 'center',
    //   disabled: false,
    //   show: true,
    //   minWidth: '160',
    // },
    {
      label: t('recharge_list.table.audit_status'),
      prop: 'audit_status',
      align: 'center',
      disabled: false,
      show: true,
      minWidth: '80',
    },
  ]
}
